export default __webpack_public_path__ + "static/social media 10-cbe51093c77473dcc5f43e95b60e1871.webp";